var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgSimpleMinus = function SvgSimpleMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    strokeWidth: 2,
    stroke: "#575D9B",
    d: "M1.255 5h8.836M5.673 1v8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    fill: "#fff",
    d: "M2.314.174H9.62v3.217H2.314z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    fill: "#fff",
    d: "M4.16 2.669h2.883v.859H4.16zM2.81 6.472h6.38v3.558H2.81z"
  })));
};

export default SvgSimpleMinus;